import{useMemo as e}from"react";import r from"../FilePreview.js";function useFilePreview(i){return e(function(){if(null!=i)return"string"==typeof i?i:r.getURL(i)},[i])}export{useFilePreview as default};
//# sourceMappingURL=useFilePreview.js.map
